import * as React from 'react';
import { IProgramWithPaymentCalculation } from '../../../../../../types/mortgage';
import * as styles from './ProgramItem.css';
import { ArticleParagraph1, UIHeading4 } from '@cian/ui-kit';
import { programIcons } from '../../../../assets';
import { numberToPrettyString } from '@cian/utils';

interface IProgramItemProps extends IProgramWithPaymentCalculation {
  onClick(): void;
}

export const ProgramItem: React.FC<IProgramItemProps> = ({ id, name, payment, rate, onClick }) => {
  return (
    <div className={styles['item']} onClick={onClick}>
      <div className={styles['title']}>
        <UIHeading4>{name}</UIHeading4>
      </div>
      <div className={styles['content']}>
        <img className={styles['icon']} src={programIcons[id]} />
        <div>
          <ArticleParagraph1>{numberToPrettyString(payment)} ₽/мес</ArticleParagraph1>
          <ArticleParagraph1>{rate}%</ArticleParagraph1>
        </div>
      </div>
    </div>
  );
};
